import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

// Monthly
export const OccurrenceTypeMonthlySchema = Type.Literal('MONTHLY', {
  $id: 'OccurrenceTypeMonthlySchema',
});

export type MonthlyOccurrence = Static<typeof MonthlyOccurrenceSchema>;
export const MonthlyOccurrenceSchema = Type.Object(
  {
    occurrenceType: OccurrenceTypeMonthlySchema,
    startDate: Type.String({
      format: 'date',
      formatMaximum: { $data: '1/endDate' },
    }),
    endDate: Type.String({
      format: 'date',
      formatMinimum: { $data: '1/startDate' },
    }),
  },
  { additionalProperties: false, $id: 'MonthlyOccurrenceSchema' }
);

// Weekly
export const OccurrenceTypeWeeklySchema = Type.Literal('WEEKLY', {
  $id: 'OccurrenceTypeWeeklySchema',
});

export type WeeklyOccurrence = Static<typeof WeeklyOccurrenceSchema>;
export const WeeklyOccurrenceSchema = Type.Object(
  {
    occurrenceType: OccurrenceTypeWeeklySchema,
    startDate: Type.String({
      format: 'date',
      formatMaximum: { $data: '1/endDate' },
    }),
    endDate: Type.String({
      format: 'date',
      formatMinimum: { $data: '1/startDate' },
    }),
  },
  { additionalProperties: false, $id: 'WeeklyOccurrenceSchema' }
);

// Single
export const OccurrenceTypeSingleSchema = Type.Literal('SINGLE', {
  $id: 'OccurrenceTypeSingleSchema',
});

export type SingleOccurrence = Static<typeof SingleOccurrenceSchema>;
export const SingleOccurrenceSchema = Type.Object(
  {
    occurrenceType: OccurrenceTypeSingleSchema,
    startDate: Type.String({
      format: 'date',
      formatMaximum: { $data: '1/endDate' },
    }),
    endDate: Type.String({
      format: 'date',
      formatMinimum: { $data: '1/startDate' },
    }),
  },
  { additionalProperties: false, $id: 'SingleOccurrenceSchema' }
);

// Union
// Important: When adding more, make sure to update schema for create lottery too
export type Occurrence = Static<typeof OccurrenceSchema>;
export const OccurrenceSchema = Type.Union(
  [MonthlyOccurrenceSchema, WeeklyOccurrenceSchema, SingleOccurrenceSchema],
  {
    $id: 'OccurrenceSchema',
  }
);

export type OccurrenceType = Static<typeof OccurrenceTypeSchema>;
export const OccurrenceTypeSchema = Type.Union(
  [OccurrenceTypeMonthlySchema, OccurrenceTypeWeeklySchema, OccurrenceTypeSingleSchema],
  {
    $id: 'OccurrenceTypeSchema',
  }
);
